// ============================
// RECOMMENDED PRODUCTS VIA API
// ============================		

export function recommend() {

	// Find the container that will hold the recommendations
	var list = document.querySelector("#recommended-products");
	// Get the product id to request the product recommendations
	var productId = list.dataset.productId;

	const limit = list.dataset.limit;

	const wasText = document.querySelector('#was-text').value || '';
	
	Shopify.money_format = list.dataset.moneyFormat;

	fetch(`/recommendations/products.json?product_id=${productId}&limit=${limit}`)
 .then(response => response.json())
 .then(({ products }) => {
	
		if (products.length === 0) {
			return hideRecommendationsSection();
		}
	
		return products.map((product) => {
			return (async () => {
				return {
					product: product,
					variants: await getSKUs(product)
				}
			})();
		});
		// Append product recommendations to the DOM.
		//return list.innerHTML = products.map(function(product) { return renderProduct(product) }).join("");
	})
	.then(products => {
		return Promise.all(products);
	})
	.then(items => {
		
		let htmlString = items.map(item => {

			return renderProduct(item.product, item.variants.join(","))
		}).join("");

		return list.innerHTML = htmlString;
	})
	.then(()=> {
		window.lazy.init();
		window.cardScores();
	})
		
		
	function hideRecommendationsSection() {
		list.style.display = "none";
	}

	async function getSKUs(product) {

		const productData = await fetch(`${Shopify.routes.root}products/${product.handle}.js`)
			.then(response => response.json())
			.then(response => response.variants.map(item => item.sku));
	
			return productData;
	};
		
	function renderProduct(product, variants) {

		return `<article class="card product-card flex direction-column justify-between text-center  small" data-sku="${ variants }">

			${ product.compare_at_price ? `<span class="sticker">SALE</span>` : '' }
			
			<div class="stack">
				<figure class="frame frame--1x1">
					<img data-src="${ product.featured_image }" alt="${ product.title }" class="lazy">
				</figure>
		
				<div class="stack stack--s align-center product-card__content">
					<div class="product-card__review js-card-review" hidden></div>
					<a class="card__link" href="${ product.url }"><h3 class="h h4">${ product.title }</h3></a>
		
				</div>
		
			</div>
		
			<div class="price flex justify-center">
				<div class="js-price ${ product.compare_at_price ? `price__sale` : '' }">${ Shopify.formatMoney(product.price, window.moneyFormat) }</div>
				${ product.compare_at_price ? `	<span class="vh">${wasText}</span><div class="price__was">${Shopify.formatMoney(product.compare_at_price, window.moneyFormat)}</div>` : '' }
			</div>
		
		</article>`
	}
};